import { render, staticRenderFns } from "./WelcomeDashboardMobile.vue?vue&type=template&id=b324ce2c&scoped=true&"
import script from "./WelcomeDashboardMobile.vue?vue&type=script&lang=js&"
export * from "./WelcomeDashboardMobile.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDashboardMobile.vue?vue&type=style&index=0&id=b324ce2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b324ce2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b324ce2c')) {
      api.createRecord('b324ce2c', component.options)
    } else {
      api.reload('b324ce2c', component.options)
    }
    module.hot.accept("./WelcomeDashboardMobile.vue?vue&type=template&id=b324ce2c&scoped=true&", function () {
      api.rerender('b324ce2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages-mobile/Dashboard/WelcomeDashboardMobile.vue"
export default component.exports